import React, { useEffect, useState } from "react";
import { Heart, Sparkles } from "lucide-react";
import api from "../lib/api";
import TierBadge from "./TierBadge";

const formatRelative = (iso) => {
    if (!iso) return "";
    const d = new Date(iso);
    const diff = (Date.now() - d.getTime()) / 1000;
    if (diff < 60) return "just now";
    if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
    if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
    if (diff < 86400 * 7) return `${Math.floor(diff / 86400)}d ago`;
    return d.toLocaleDateString();
};

const DonorWall = () => {
    const [donors, setDonors] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.get("/donors/wall", { params: { limit: 9 } })
            .then((r) => setDonors(r.data))
            .catch(() => {})
            .finally(() => setLoading(false));
    }, []);

    if (loading) return null;
    if (donors.length === 0) return null;

    return (
        <section className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 pb-20 lg:pb-24" data-testid="donor-wall-section">
            <div className="text-center mb-10">
                <p className="text-xs tracking-[0.18em] uppercase font-bold text-[#E53935] mb-3 flex items-center justify-center gap-2">
                    <Sparkles className="w-3.5 h-3.5" strokeWidth={2} />
                    Recent supporters
                </p>
                <h2 className="font-heading text-3xl sm:text-4xl text-[#1C252E] font-medium tracking-tight">
                    Powered by these amazing humans
                </h2>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="donor-wall-grid">
                {donors.map((d, i) => (
                    <div
                        key={i}
                        data-testid={`donor-card-${i}`}
                        className="bg-white border border-black/5 rounded-2xl p-5 hover:border-[#E53935]/40 transition-all"
                    >
                        <div className="flex items-start gap-4">
                            <div className="w-12 h-12 rounded-full bg-gradient-to-br from-[#F2D8D5] to-[#FDFBF7] flex items-center justify-center flex-shrink-0">
                                <Heart className="w-5 h-5 text-[#E53935]" fill="#E53935" strokeWidth={1.5} />
                            </div>
                            <div className="flex-1 min-w-0">
                                <div className="flex items-baseline justify-between gap-2 flex-wrap">
                                    <p className="font-heading text-base text-[#1C252E] font-medium truncate">{d.display_name}</p>
                                    <p className="font-heading text-lg text-[#E53935] font-medium whitespace-nowrap">
                                        ${Math.round(d.amount).toLocaleString()}
                                        {d.frequency === "monthly" && <span className="text-xs text-[#4A5568] font-normal">/mo</span>}
                                    </p>
                                </div>
                                {d.tier && <div className="mt-1.5"><TierBadge tier={d.tier} /></div>}
                                {d.message && (
                                    <p className="text-sm text-[#4A5568] mt-2 leading-relaxed italic line-clamp-2">"{d.message}"</p>
                                )}
                                <p className="text-xs text-[#4A5568] mt-2">{formatRelative(d.created_at)}</p>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default DonorWall;
